//import { JSDOM } from 'jsdom';
import './style.css';
import 'ol-layerswitcher/src/ol-layerswitcher.css';
import Map from 'ol/Map';
import TileGrid from 'ol/tilegrid/TileGrid';
import TileLayer from 'ol/layer/Tile';
import {Vector as VectorLayer} from 'ol/layer';
import {GeoJSON}from 'ol/format';
import View from 'ol/View';
import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import {Cluster, OSM, TileImage, TileWMS, Vector as vectorSource} from 'ol/source';
import {getCenter, getWidth} from 'ol/extent';
import {get as getProjection, transformExtent} from 'ol/proj';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import {Circle as CircleStyle, Fill, Stroke, Style, Icon, Text} from 'ol/style';
import Overlay from 'ol/Overlay';
import {defaults as defaultControls, Control} from 'ol/control';
import LayerSwitcher from 'ol-layerswitcher';
import LayerGroup from 'ol/layer/Group';

// Define the CRS for each layer
const crsByLayer = {
  'Layer 1': 'EPSG:27700',
};

const geojsonStruct = {
  type: "FeatureCollection",
  'crs': {
    'type': 'name',
    'properties': {
      'name': 'EPSG:27700',
    }
  },
  features: [],
};

const image = new CircleStyle({
  radius: 5,
  fill: new Fill({
    color: 'rgba(0, 0, 0, 0.4)'
  }),
  stroke: new Stroke({color: 'black', width: 1}),
});
const image_imp = new CircleStyle({
  radius: 5,
  fill: new Fill({
    color: 'rgba(255, 0, 0, 0.4)'
  }),
  stroke: new Stroke({color: 'red', width: 1}),
});

const styles = {
  'Point': new Style({
    image: image,
  }),
  'LineString': new Style({
    stroke: new Stroke({
      color: 'green',
      width: 1,
    }),
  }),
  'MultiLineString': new Style({
    stroke: new Stroke({
      color: 'green',
      width: 1,
    }),
  }),
  'MultiPoint': new Style({
    image: image,
  }),
  'MultiPolygon': new Style({
    stroke: new Stroke({
      color: 'yellow',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 0, 0.1)',
    }),
  }),
  'Polygon': new Style({
    stroke: new Stroke({
      color: 'blue',
      lineDash: [4],
      width: 3,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    }),
  }),
  'GeometryCollection': new Style({
    stroke: new Stroke({
      color: 'magenta',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgb(255,0,255, 0.1)',
    }),
    image: new CircleStyle({
      radius: 10,
      fill: new Fill({
        color: 'rgb(255,0,255, 0.1)',
      }),
      stroke: new Stroke({
        color: 'magenta',
      }),
    }),
  }),
  'Circle': new Style({
    stroke: new Stroke({
      color: 'red',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgba(255,0,0,0.2)',
    }),
  }),
};
const styles_imp = {
  'Point': new Style({
    image: image_imp,
  }),
};

const styleFunction = function (feature) {
  return styles[feature.getGeometry().getType()];
};
const styleFunction_imp = function (feature) {
  return styles_imp[feature.getGeometry().getType()];
};

// Cluster variables

const circleDistanceMultiplier = 1;
const circleFootSeparation = 28;
const circleStartAngle = Math.PI / 2;
const convexHullFill = new Fill({
  color: 'rgba(255, 153, 0, 0.4)',
});
const convexHullStroke = new Stroke({
  color: 'rgba(204, 85, 0, 1)',
  width: 1.5,
});
const outerCircleFill = new Fill({
  color: 'rgba(255, 153, 102, 0.3)',
});
const innerCircleFill = new Fill({
  color: 'rgba(255, 165, 0, 0.7)',
});
const textFill = new Fill({
  color: '#fff',
});
const textStroke = new Stroke({
  color: 'rgba(0, 0, 0, 0.6)',
  width: 3,
});
const innerCircle = new CircleStyle({
  radius: 14,
  fill: innerCircleFill,
});
const outerCircle = new CircleStyle({
  radius: 20,
  fill: outerCircleFill,
});
const darkIcon = new Icon({
  src: './emoticon-cool.svg',
});
const lightIcon = new Icon({
  src: './emoticon-cool-outline.svg',
});

/**
 * Single feature style, users for clusters with 1 feature and cluster circles.
 * @param {Feature} clusterMember A feature from a cluster.
 * @return {Style} An icon style for the cluster member's location.
 */
 function clusterMemberStyle(clusterMember) {
  return new Style({
    geometry: clusterMember.getGeometry(),
    image: clusterMember.get('LEISTUNG') > 5 ? darkIcon : lightIcon,
  });
}

let clickFeature, clickResolution;

proj4.defs(
  'EPSG:27700',
  '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 ' +
    '+x_0=400000 +y_0=-100000 +ellps=airy ' +
    '+towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 ' +
    '+units=m +no_defs'
);
proj4.defs(
  'EPSG:23032',
  '+proj=utm +zone=32 +ellps=intl ' +
    '+towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs'
);
proj4.defs(
  'EPSG:5479',
  '+proj=lcc +lat_1=-76.66666666666667 +lat_2=' +
    '-79.33333333333333 +lat_0=-78 +lon_0=163 +x_0=7000000 +y_0=5000000 ' +
    '+ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
);
proj4.defs(
  'EPSG:21781',
  '+proj=somerc +lat_0=46.95240555555556 ' +
    '+lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel ' +
    '+towgs84=674.4,15.1,405.3,0,0,0,0 +units=m +no_defs'
);
proj4.defs(
  'EPSG:3413',
  '+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +k=1 ' +
    '+x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs'
);
proj4.defs(
  'EPSG:2163',
  '+proj=laea +lat_0=45 +lon_0=-100 +x_0=0 +y_0=0 ' +
    '+a=6370997 +b=6370997 +units=m +no_defs'
);
proj4.defs(
  'ESRI:54009',
  '+proj=moll +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 ' + '+units=m +no_defs'
);
register(proj4);

const proj27700 = getProjection('EPSG:27700');
proj27700.setExtent([-650000, -150000, 1350000, 1450000]);

const proj23032 = getProjection('EPSG:23032');
proj23032.setExtent([-1206118.71, 4021309.92, 1295389.0, 8051813.28]);

const proj5479 = getProjection('EPSG:5479');
proj5479.setExtent([6825737.53, 4189159.8, 9633741.96, 5782472.71]);

const proj21781 = getProjection('EPSG:21781');
proj21781.setExtent([485071.54, 75346.36, 828515.78, 299941.84]);

const proj3413 = getProjection('EPSG:3413');
proj3413.setExtent([-6194304, -6194304, 6194304, 6194304]);

const proj2163 = getProjection('EPSG:2163');
proj2163.setExtent([-8040784.5135, -2577524.921, 3668901.4484, 4785105.1096]);

const proj54009 = getProjection('ESRI:54009');
proj54009.setExtent([-18e6, -9e6, 18e6, 9e6]);

const layers = {};

/**
       * Elements that make up the popup.
       */
 var container = document.getElementById('popup');
 var content = document.getElementById('popup-content');
 var closer = document.getElementById('popup-closer');

/**
       * Add a click handler to hide the popup.
       * @return {boolean} Don't follow the href.
       */
  closer.onclick = function() {
    overlay.setPosition(undefined);
    closer.blur();
    return false;
  };
 layers['osm'] = new TileLayer({
  source: new OSM(),
});
/**
       * Create an overlay to anchor the popup to the map.
       */
 var overlay = new Overlay({
  element: container,
  autoPan: true,
  autoPanAnimation: {
    duration: 250
  }
});
layers['wms4326'] = new TileLayer({
  source: new TileWMS({
    url: 'https://ahocevar.com/geoserver/wms',
    crossOrigin: '',
    params: {
      'LAYERS': 'ne:NE1_HR_LC_SR_W_DR',
      'TILED': true,
    },
    projection: 'EPSG:4326',
  }),
});



// vector layer source

var vSource = new VectorSource({
//	url:"./pos-arcmap.geojson",
	url:"./results-all-pt.geojson",
  format: new GeoJSON(),
  useSpatialIndex: false,
});

layers['points'] = new VectorLayer ({
  source:vSource,
  style: styleFunction,
  title: 'points',
});

//var vpSource = new VectorSource({
  //	url:"./pos-arcmap.geojson",
//    url:"./results-all-poly.geojson",
//    format: new GeoJSON(),
//    useSpatialIndex: false,
//});
  
//layers['polygons'] = new VectorLayer ({
//    source:vpSource,
//    style: styleFunction,
//    title: 'polygons',
//    visible: false,
//});

//var vmSource = new VectorSource({
    //	url:"./pos-arcmap.geojson",
//    url:"./results-all-multi.geojson",
//    format: new GeoJSON(),
//   useSpatialIndex: false,
//});
    
//layers['multi'] = new VectorLayer ({
//    source:vmSource,
//    style: styleFunction,
//    title: 'multi',
//    visible: false,
//});

var vsSource = new VectorSource({
  //	url:"./pos-arcmap.geojson",
  url:"./results-SIOS.geojson",
  format: new GeoJSON(),
  useSpatialIndex: false,
});
  
layers['sios'] = new VectorLayer ({
  source:vsSource,
  style: styleFunction_imp,
  title: 'sios',
  visible: false,
});

//console.log(multigeojson);
//console.log(vSource.getFeaturesCollection());

//var pSource = new VectorSource({
//  features: new GeoJSON({dataProjection: 'EPSG:3413'}).readFeatures(multigeojson),
//  useSpatialIndex: false,
//});
//  console.log(pSource);

//console.log(pSource);
// vector LAYER
//console.log(pSource.getFeaturesCollection());

//var vLayer = new VectorLayer ({
//  source:vSource,
//  style: styleFunction,
//});

layers['wms21781'] = new TileLayer({
  source: new TileWMS({
    attributions:
      '© <a href="https://shop.swisstopo.admin.ch/en/products/maps/national/lk1000"' +
      'target="_blank">Pixelmap 1:1000000 / geo.admin.ch</a> | ARCMAP &copy; NERSC',
    crossOrigin: 'anonymous',
    params: {
      'LAYERS': 'ch.swisstopo.pixelkarte-farbe-pk1000.noscale',
      'FORMAT': 'image/jpeg',
    },
    url: 'https://wms.geo.admin.ch/',
    projection: 'EPSG:21781',
  }),
});

const parser = new WMTSCapabilities();

layers['wmts3413'] = new TileLayer();
const urlA =
  'https://map1.vis.earthdata.nasa.gov/wmts-arctic/' +
  'wmts.cgi?SERVICE=WMTS&request=GetCapabilities';
fetch(urlA)
  .then(function (response) {
    return response.text();
  })
  .then(function (text) {
    const result = parser.read(text);
    const options = optionsFromCapabilities(result, {
      layer: 'OSM_Land_Mask',
      matrixSet: 'EPSG3413_250m',
    });
    options.crossOrigin = '';
    options.projection = 'EPSG:3413';
    options.wrapX = true;
    layers['wmts3413'].setSource(new WMTS(options));
  });

//layers['bng'] = new TileLayer();
//const urlB =
//  'https://tiles.arcgis.com/tiles/qHLhLQrcvEnxjtPr/arcgis/rest/services/OS_Open_Raster/MapServer/WMTS';
//fetch(urlB)
//  .then(function (response) {
//    return response.text();
//  })
//  .then(function (text) {
//    const result = parser.read(text);
//    const options = optionsFromCapabilities(result, {
//      layer: 'OS_Open_Raster',
//    });
//    options.attributions =
//      'Contains OS data © Crown Copyright and database right ' +
//      new Date().getFullYear();
//    options.crossOrigin = '';
//    options.projection = 'EPSG:3413';
//    options.wrapX = false;
//    layers['bng'].setSource(new WMTS(options));
//  });

//const startResolution = getWidth(getProjection('EPSG:3857').getExtent()) / 256;
const startResolution = getWidth(getProjection('EPSG:3413').getExtent()) / 256;
const resolutions = new Array(22);
for (let i = 0, ii = resolutions.length; i < ii; ++i) {
  resolutions[i] = startResolution / Math.pow(2, i);
}

layers['states'] = new TileLayer({
  source: new TileWMS({
    url: 'https://ahocevar.com/geoserver/wms',
    crossOrigin: '',
    params: {'LAYERS': 'topp:states'},
    serverType: 'geoserver',
    tileGrid: new TileGrid({
      extent: [-13884991, 2870341, -7455066, 6338219],
      resolutions: resolutions,
      tileSize: [512, 256],
    }),
    projection: 'EPSG:3857',
  }),
});

const geojsonFile = './results-all.geojson';
//var geojsonObject = geojsonFile;
//var pSource;

const pointgeojson = {
  type: "FeatureCollection",
  'crs': {
    'type': 'name',
    'properties': {
      'name': 'EPSG:27700',
    },
  },
  features: [],
};
const polygeojson = {
  type: "FeatureCollection",
  'crs': {
    'type': 'name',
    'properties': {
      'name': 'EPSG:27700',
    },
  },
  features: [],
};
var multigeojson = {
  type: "FeatureCollection",
  'crs': {
    'type': 'name',
    'properties': {
      'name': 'EPSG:27700',
    },
  },
  features: [],
};

layers['pointlayer'] = new VectorLayer();

fetch(geojsonFile)
.then(response => response.json()) 
.then(json => {
  json.forEach(function (feature, index) {
//    console.log(index);
//    console.log(feature);
    if (feature.geometry.type == "Point") {
      pointgeojson.features.push(feature);
    } else if ((feature.geometry.type == "Polygon")) {
      polygeojson.features.push(feature);
    } else {
      multigeojson.features.push(feature);
    }
  }
  );
  return pointgeojson;
})
.then(function (points){
  layers['pointlayer'].setSource(new VectorSource({
   features: new GeoJSON().readFeatures(points, {
     dataProjection: 'EPSG:27700',
      featureProjection: 'EPSG:27700',
  }),
//      source : new GeoJSON({
//        style: styleFunction,
//        defaultProjection: 'EPSG:4326',
//        projection: "EPSG:4326",
//        object: points,
//    }),
  }));
 });


//console.log(layers['pointlayer']);
let hoverFeature;
/**
 * Style for convex hulls of clusters, activated on hover.
 * @param {Feature} cluster The cluster feature.
 * @return {Style} Polygon style for the convex hull of the cluster.
 */
function clusterHullStyle(cluster) {
  if (cluster !== hoverFeature) {
    return;
  }
  const originalFeatures = cluster.get('features');
  const points = originalFeatures.map((feature) =>
    feature.getGeometry().getCoordinates()
  );
  return new Style({
    geometry: new Polygon([monotoneChainConvexHull(points)]),
    fill: convexHullFill,
    stroke: convexHullStroke,
  });
}  
  /**
 * Style for clusters with features that are too close to each other, activated on click.
 * @param {Feature} cluster A cluster with overlapping members.
 * @param {number} resolution The current view resolution.
 * @return {Style} A style to render an expanded view of the cluster members.
 */
 function clusterCircleStyle(cluster, resolution) {
  if (cluster !== clickFeature || resolution !== clickResolution) {
    return;
  }
  const clusterMembers = cluster.get('features');
  const centerCoordinates = cluster.getGeometry().getCoordinates();
  return generatePointsCircle(
    clusterMembers.length,
    cluster.getGeometry().getCoordinates(),
    resolution
  ).reduce((styles, coordinates, i) => {
    const point = new Point(coordinates);
    const line = new LineString([centerCoordinates, coordinates]);
    styles.unshift(
      new Style({
        geometry: line,
        stroke: convexHullStroke,
      })
    );
    styles.push(
      clusterMemberStyle(
        new Feature({
          ...clusterMembers[i].getProperties(),
          geometry: point,
        })
      )
    );
    return styles;
  }, []);
}

/**
 * From
 * https://github.com/Leaflet/Leaflet.markercluster/blob/31360f2/src/MarkerCluster.Spiderfier.js#L55-L72
 * Arranges points in a circle around the cluster center, with a line pointing from the center to
 * each point.
 * @param {number} count Number of cluster members.
 * @param {Array<number>} clusterCenter Center coordinate of the cluster.
 * @param {number} resolution Current view resolution.
 * @return {Array<Array<number>>} An array of coordinates representing the cluster members.
 */
 function generatePointsCircle(count, clusterCenter, resolution) {
  const circumference =
    circleDistanceMultiplier * circleFootSeparation * (2 + count);
  let legLength = circumference / (Math.PI * 2); //radius from circumference
  const angleStep = (Math.PI * 2) / count;
  const res = [];
  let angle;

  legLength = Math.max(legLength, 35) * resolution; // Minimum distance to get outside the cluster icon.

  for (let i = 0; i < count; ++i) {
    // Clockwise, like spiral.
    angle = circleStartAngle + i * angleStep;
    res.push([
      clusterCenter[0] + legLength * Math.cos(angle),
      clusterCenter[1] + legLength * Math.sin(angle),
    ]);
  }

  return res;
}

function clusterStyle(feature) {
  const size = feature.get('features').length;
  if (size > 1) {
    return [
      new Style({
        image: outerCircle,
      }),
      new Style({
        image: innerCircle,
        text: new Text({
          text: size.toString(),
          fill: textFill,
          stroke: textStroke,
        }),
      }),
    ];
  } else {
    const originalFeature = feature.get('features')[0];
    return clusterMemberStyle(originalFeature);
  }
}
const clusterSource = new Cluster({
  attributions:
    'Data: <a href="https://www.nersc.no">NERSC</a>',
  distance: 35,
  source: vSource,
});
// Layer displaying the convex hull of the hovered cluster.
const clusterHulls = new VectorLayer({
  source: clusterSource,
  style: clusterHullStyle,
});

// Layer displaying the clusters and individual features.
const clusters = new VectorLayer({
  source: clusterSource,
  style: clusterStyle,
});

// Layer displaying the expanded view of overlapping cluster members.
const clusterCircles = new VectorLayer({
  source: clusterSource,
  style: clusterCircleStyle,
});


const map = new Map({
//  layers: [layers['wms4326'], clusterHulls, clusters, clusterCircles, layers['polygons'], layers['multi'], layers['sios']],
//  layers: [layers['wms4326'], layers['points'], layers['polygons'], layers['multi'], layers['sios']],
//  layers: [layers['wms4326'], layers['points'], layers['sios']],
//  controls: defaultControls().extend([new LayerToggleControl()]),
  layers: [],
  target: 'map',
  overlays: [overlay],
  view: new View({
    projection: 'EPSG:4326',
    center: [90, 0],
    zoom: 2,
    minZoom: 1,
    wrapDateLine: true,
  }),
});
// Define a custom control that will hold the layer toggle buttons
class LayerToggleControl extends Control {
  constructor(layers) {
    const element = document.getElementById('layer-switcher');
    super({
      element: element,
      target: document.getElementById('sidebar'),
    });
//    this.layers = map.getLayers().getArray();
    this.layers = layers;
//    this.element = element;
    element.className = 'layer-toggle';
    layers.forEach(layer => {
//      console.log(layer);
      const layerName = layer.get('name');
      if (layerName) {
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.checked = layer.getVisible();
        input.addEventListener( 'change', () => {
          layer.setVisible(this.checked);
        }, false);
        const label = document.createElement('label');
        label.innerText = layerName;
        label.appendChild(input);
        element.appendChild(label);
        }
    });
  }
}
// Create a custom control with checkboxes
class LayerControl extends Control {
  constructor(groupsAndLayers) {
//    console.log(groupsAndLayers)
    const element = document.getElementById('layer-switcher');
    element.className = 'ol-control layer-control';

    const form = document.createElement('form');
    element.appendChild(form);

    for (const group in groupsAndLayers) {
//      console.log(group);
      const groupLabel = document.createElement('label');
      groupLabel.innerHTML = group;
      form.appendChild(groupLabel);

      const groupContainer = document.createElement('div');
      form.appendChild(groupContainer);

      for (const layer of groupsAndLayers[group]) {
        const layerId = layer.get('id');
        const layerLabel = document.createElement('label');
        layerLabel.innerHTML = layerId;
        groupContainer.appendChild(layerLabel);

        const layerInput = document.createElement('input');
        layerInput.type = 'checkbox';
        layerInput.value = layerId;
        layerInput.checked = layer.getVisible();
        layerInput.onchange = () => {
          layer.setVisible(layerInput.checked);
        };
        layerLabel.insertBefore(layerInput, layerLabel.firstChild);
      }
    }

    super({
      element: element,
      target: document.getElementById('sidebar'),
    });
  }
}

//map.addLayer(vLayer);

//const baseLayerSelect = document.getElementById('base-layer');
const baseLayerSelect = "osm";
//const overlayLayerSelect = document.getElementById('overlay-layer');
const overlayLayerSelect = "pointlayer";
//const viewProjSelect = document.getElementById('view-projection');
const viewProjSelect = "EPSG:3413";
//const renderEdgesCheckbox = document.getElementById('render-edges');
const renderEdgesCheckbox = false;
let renderEdges = false;

// Get GeoJSON polygon features
const geojsonPoly = './results-all-poly.geojson';
const geojsonMulti = './results-all-multi.geojson';
// Load the GeoJSON file and parse it
const dataPromise = fetch(geojsonPoly).then((response) => response.json());
const multidataPromise = fetch(geojsonMulti).then((response) => response.json());

const layersPromise = dataPromise.then((data) => {
  // Iterate over each feature and create a separate VectorLayer for each one
  const featuresByID = {};
  const layerGroupsByID = {};
  const otherlayers = [];
  const geojsonFeatures = [];
  const allfeatures = new GeoJSON().readFeatures(data, {
    featureProjection: 'EPSG:3413',
  });
//  console.log(allfeatures)
  const alllayers = allfeatures.map((feature) => {
//    console.log(feature);
    const platformName = feature.get('platform_name');
    return new VectorLayer({
      source: new VectorSource({
        features: [feature],
      }),
      style: new Style({
        stroke: new Stroke({
          color: 'blue',
          width: 1,
        }),
        fill: new Fill({
          color: 'rgba(0,0,255,0.1)',
        }),
      }),
      visible: false,
      name: platformName, // Set the layer name
    });
  });

    return alllayers;
  });
  const multilayersPromise = multidataPromise.then((data) => {
    // Iterate over each feature and create a separate VectorLayer for each one
    const featuresByID = {};
    const layerGroupsByID = {};
    const otherlayers = [];
    const geojsonFeatures = [];
    const multifeatures = new GeoJSON().readFeatures(data, {
      featureProjection: 'EPSG:3413',
    });
    //console.log(allfeatures)
    const multilayers = multifeatures.map((feature) => {
    //  console.log(feature);
      const platformName = feature.get('platform_name');
      return new VectorLayer({
        source: new VectorSource({
          features: [feature],
        }),
        style: styleFunction,
        visible: false,
        name: platformName, // Set the layer name
      });
    });
  
      return multilayers;
});
    

// Wait for both the data loading and the creation of the layers
Promise.all([dataPromise, layersPromise, multilayersPromise])
  .then(([geojson, alllayers, multilayers]) => {
    // Add an OSM tile layer
//    console.log(multilayers);
    const osmLayer = new TileLayer({
      source: new OSM(),
    });
    map.addLayer(osmLayer);
    map.addLayer(layers['points']);
    map.addLayer(layers['sios']);
    alllayers.forEach((player) => {
  //    console.log(player);
      map.addLayer(player);
    });
    multilayers.forEach((mlayer) => {
      //    console.log(player);
          map.addLayer(mlayer);
    });
     
    // Create the checkboxes for additional layers
    const checkboxContainer = document.getElementById('checkboxContainer');

    const additionalLayers = [layers['points'], layers['sios']]

    additionalLayers.forEach((layer, index) => {
      const checkboxLabel = document.createElement('label');
      checkboxLabel.classList.add('checkbox-label');

      const checkboxInput = document.createElement('input');
      checkboxInput.type = 'checkbox';
      checkboxInput.value = index.toString();
      checkboxInput.checked = layer.getVisible();
      checkboxInput.addEventListener('change', () => {
      layer.setVisible(checkboxInput.checked);
      });
      let checkboxText = "";
      if (layer.get('title') === "sios")
        checkboxText = document.createTextNode("Not assessed systems (SIOS)");
      else
        checkboxText = document.createTextNode("Observing points");

      checkboxLabel.appendChild(checkboxInput);
      checkboxLabel.appendChild(checkboxText);
      checkboxContainer.appendChild(checkboxLabel);
    });

    const layerSelectContainer = document.getElementById('polySelectDiv');
    // Create the select element in the sidebar
    const layerSelect = document.createElement('select');
    layerSelect.multiple = true; // Enable multiple selection
    layerSelect.size = 10; // Number of visible options (you can adjust this value)

    layerSelect.id = 'layerSelect';
    layerSelect.addEventListener('change', (event) => {
      const selectedOptions = Array.from(event.target.selectedOptions);
      alllayers.forEach((layer) => {
        layer.setVisible(selectedOptions.includes(layer.option));
      });
    });
    alllayers.forEach((layer, index) => {
      const option = document.createElement('option');
      option.value = index.toString();
      option.text = layer.get('name');
      layer.option = option; // Store the option on the layer for easy access
      layerSelect.appendChild(option);
    });

    layerSelectContainer.appendChild(layerSelect);

    const filterLabel = document.createElement('label');
    filterLabel.textContent = 'Type to filter:';

    const filterInput = document.createElement('input');
    filterInput.type = 'text';
    filterInput.style.width = '100%';
    filterInput.placeholder = 'Type to filter';
    
    const originalOptions = Array.from(layerSelect.options); // Store the original options
    let filteredOptions = [...originalOptions]; // Copy the original options initially

    filterInput.addEventListener('input', () => {
      const filterValue = filterInput.value.toLowerCase();
    
      // Filter the options based on the entered text
      const matchingOptions = filteredOptions.filter((option) => {
        return option.text.toLowerCase().includes(filterValue);
      });
    
      // Clear the options
      layerSelect.options.length = 0;
    
      // Add the matching options to the multi-select box
      matchingOptions.forEach((option) => {
        layerSelect.appendChild(option);
      });
    });
    filterInput.addEventListener('keyup', (event) => {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        const filterValue = filterInput.value.toLowerCase();
    
        // Update the filteredOptions array based on the current filter
        filteredOptions = originalOptions.filter((option) => {
          return option.text.toLowerCase().includes(filterValue);
        });
      }
    });
    layerSelectContainer.appendChild(filterLabel);
    layerSelectContainer.appendChild(filterInput);
      
    const multiSelectContainer = document.getElementById('multiSelectDiv');
    // Create the select element in the sidebar
    const multilayerSelect = document.createElement('select');
    multilayerSelect.multiple = true; // Enable multiple selection
    multilayerSelect.size = 10; // Number of visible options (you can adjust this value)

    multilayerSelect.id = 'multiSelect';
    multilayerSelect.addEventListener('change', (event) => {
      const selectedOptions = Array.from(event.target.selectedOptions);
      multilayers.forEach((layer) => {
        layer.setVisible(selectedOptions.includes(layer.option));
      });
    });
    multilayers.forEach((layer, index) => {
      const option = document.createElement('option');
      option.value = index.toString();
      option.text = layer.get('name');
      layer.option = option; // Store the option on the layer for easy access
      multilayerSelect.appendChild(option);
    });
    multiSelectContainer.appendChild(multilayerSelect);

    const multifilterLabel = document.createElement('label');
    multifilterLabel.textContent = 'Type to filter:';

    const multifilterInput = document.createElement('input');
    multifilterInput.type = 'text';
    multifilterInput.style.width = '100%';
    multifilterInput.placeholder = 'Type to filter';
    
    const multioriginalOptions = Array.from(multilayerSelect.options); // Store the original options
    let multifilteredOptions = [...multioriginalOptions]; // Copy the original options initially

    multifilterInput.addEventListener('input', () => {
      const multifilterValue = multifilterInput.value.toLowerCase();
    
      // Filter the options based on the entered text
      const multimatchingOptions = multifilteredOptions.filter((option) => {
        return option.text.toLowerCase().includes(multifilterValue);
      });
    
      // Clear the options
      multilayerSelect.options.length = 0;
    
      // Add the matching options to the multi-select box
      multimatchingOptions.forEach((option) => {
        multilayerSelect.appendChild(option);
      });
    });
    multifilterInput.addEventListener('keyup', (event) => {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        const multifilterValue = multifilterInput.value.toLowerCase();
    
        // Update the filteredOptions array based on the current filter
        multifilteredOptions = multioriginalOptions.filter((option) => {
          return option.text.toLowerCase().includes(multifilterValue);
        });
      }
    });
    multiSelectContainer.appendChild(multifilterLabel);
    multiSelectContainer.appendChild(multifilterInput);
 });

function updateViewProjection() {
//  const newProj = getProjection(viewProjSelect.value);
  const newProj = getProjection(viewProjSelect);
//  console.log(newProj);
  const newProjExtent = newProj.getExtent();
//  console.log(newProjExtent);
  const newView = new View({
    projection: newProj,
    center: getCenter(newProjExtent || [0, 0, 0, 0]),
    zoom: 0,
    extent: newProjExtent || undefined,
  });
  map.setView(newView);

  // Example how to prevent double occurrence of map by limiting layer extent
//  if (newProj.isGlobal()) {
//    layers['wms4326'].setExtent(
//      transformExtent(proj27700.getExtent(), proj27700, newProj, 2)
//    );
//  } else {
//    layers['wms4326'].setExtent(undefined);
//  }
}

/**
 * Handle change event.
 */
//viewProjSelect.onchange = function () {
//  updateViewProjection();
//};

updateViewProjection();

const updateRenderEdgesOnLayer = function (layer) {
  if (layer instanceof TileLayer) {
    const source = layer.getSource();
    if (source instanceof TileImage) {
      source.setRenderReprojectionEdges(renderEdges);
    }
  }
};

const baseLayerElements = document.querySelectorAll('.sidebar > input[type=radio]');
for (let baseLayerElement of baseLayerElements) {
  baseLayerElement.addEventListener('change', function () {
    let baseLayerElementValue = this.value;
    map.getLayers().forEach(function(element, index, array){
      let baseLayerTitle = element.get('title');
      if (baseLayerTitle != undefined) {
        element.setVisible(baseLayerTitle === baseLayerElementValue);
      }
//      console.log(element.get('title'));
    })
  });

}

map.on('singleclick', function(evt) {
  var name = map.forEachFeatureAtPixel(evt.pixel, function(feature) {
  //  console.log(feature.getKeys());
    let nameTmp = "<b>System: </b>"+feature.get('system_name') +"<br/><b>Location name: </b>"+feature.get('platform_name') +"<br/><b>Owner: </b>"+feature.get('system_institution') +"<br/><b>Start: </b>"+feature.get('temp_start') +"<br/><b>End: </b>"+feature.get('temp_end');
    return nameTmp;
  })
  if (name) {
    container.style.display="block";
    var coordinate = evt.coordinate;
    content.innerHTML = name;
    overlay.setPosition(coordinate);
  } else {
    container.style.display="none";
  }
});
map.on('pointermove', function(evt) {
  map.getTargetElement().style.cursor = map.hasFeatureAtPixel(evt.pixel) ? 'pointer' : '';
});





// map.on('pointermove', (event) => {
//   clusters.getFeatures(event.pixel).then((features) => {
//     if (features[0] !== hoverFeature) {
//       // Display the convex hull on hover.
//       hoverFeature = features[0];
//       clusterHulls.setStyle(clusterHullStyle);
//       // Change the cursor style to indicate that the cluster is clickable.
//       map.getTargetElement().style.cursor =
//         hoverFeature && hoverFeature.get('features').length > 1
//           ? 'pointer'
//           : '';
//     }
//   });
// });

// map.on('click', (event) => {
//   clusters.getFeatures(event.pixel).then((features) => {
//     if (features.length > 0) {
//       const clusterMembers = features[0].get('features');
//       if (clusterMembers.length > 1) {
//         // Calculate the extent of the cluster members.
//         const extent = createEmpty();
//         clusterMembers.forEach((feature) =>
//           extend(extent, feature.getGeometry().getExtent())
//         );
//         const view = map.getView();
//         const resolution = map.getView().getResolution();
//         if (
//           view.getZoom() === view.getMaxZoom() ||
//           (getWidth(extent) < resolution && getWidth(extent) < resolution)
//         ) {
//           // Show an expanded view of the cluster members.
//           clickFeature = features[0];
//           clickResolution = resolution;
//           clusterCircles.setStyle(clusterCircleStyle);
//         } else {
//           // Zoom to the extent of the cluster members.
//           view.fit(extent, {duration: 500, padding: [50, 50, 50, 50]});
//         }
//       }
//     }
//   });
// });
/**
 * Handle change event.
 */
//baseLayerSelect.onchange = function () {
//  const layer = layers[baseLayerSelect.value];
//  const layer = layers[baseLayerSelect];
//  if (layer) {
//    layer.setOpacity(1);
//    updateRenderEdgesOnLayer(layer);
//    map.getLayers().setAt(0, layer);
//  }
//};

/**
 * Handle change event.
 */
//overlayLayerSelect.onchange = function () {
//  const layer = layers[overlayLayerSelect.value];
//  if (layer) {
//    layer.setOpacity(0.7);
//    updateRenderEdgesOnLayer(layer);
//    map.getLayers().setAt(1, layer);
//  }
//};

/**
 * Handle change event.
 */
//renderEdgesCheckbox.onchange = function () {
//  renderEdges = renderEdgesCheckbox.checked;
//  map.getLayers().forEach(function (layer) {
//    updateRenderEdgesOnLayer(layer);
//  });
//};

